export default "/assets/images/mila-room-showcase-sm-02.3003ebd5db1f20fd.webp";